import mixpanel from "mixpanel-browser";
import { getIsOnpremise, isLoggedInUser } from "..";
import getEnv from "../getEnv";

/* this function will track duration will target event is hit */
export var trackDuration = function trackDuration(targetEvent) {
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (isOnPremise || !MIXPANEL_TOKEN || !isLoggedInUser()) {
    return;
  }
  mixpanel.time_event(targetEvent);
};